module.exports = __webpack_public_path__ + "static/media/tingchechangshiyitu.8cbba02c.png";